<template>
  <div>
    <footer class="footer_warp hidden-xs-only">
      <div class="footer_part2 clearfix">
        <div class="footer_part1_warp" v-if="showTrialBtn">
          <div class="footer_part1 clearfix">
            <div class="link1">{{$t('footer.free')}}</div>
            <router-link to="/trial" class="link-warp">
              <span class="link">{{$t('footer.apply')}}</span>
            </router-link>
          </div>
        </div>
        <div class="footer_bg_m">
          <div class="float_l float_l_text">
            <div class="footer_p_warp">
              <p class='footer_title'>{{$t('footer.more')}}</p>
              <p class="details_link">
                <router-link to="/product">{{$t('footer.products')}}</router-link>
              </p>
              <p class="details_link">
                <router-link to="/solution">{{$t('footer.solutions')}}</router-link>
              </p>
              <p class="details_link">
                <router-link to="/about">{{$t('footer.about')}}</router-link>
              </p>
            </div>
            <div class="footer_p_warp">
              <p class='footer_title'>{{$t('footer.partnership')}}</p>
              <p class='footer_p  teamwork_p1'>
                <i class="bd_icon mail_icon"></i>
                {{$t('footer.business')}}
                <a href="mailto:bd@yijia.ai" class="footer_link_m">bd@yijia.ai</a>
              </p>
              <p class='footer_p'>
                <i class="hr_icon mail_icon"></i>
                {{$t('footer.recruitment')}}
                <a href="mailto:hr@yijia.ai" class="footer_link_m">hr@yijia.ai</a>
              </p>
              <p class='footer_p'>
                <i class="pr_icon mail_icon"></i>
                {{$t('footer.media')}}
                <a href="mailto:pr@yijia.ai" class="footer_link_m">pr@yijia.ai</a>
              </p>
            </div>
          </div>
          <div class="float_l teamwork clearfix">
            <p class='footer_title'>{{$t('footer.follow')}}</p>
            <div style="margin-top: 20px;min-width: 204px">
              <a href=' http://weibo.com/dressplus' target='_blank' class='details_weibo details_icon' ></a>
              <a href='http://v.qq.com/vplus/dbf3d68a641a60b96f7512c83666adff' target='_blank' class='details_youku details_icon' ></a>
              <a href='https://www.linkedin.com/company/13604619/' target='_blank' class='details_ins details_icon' ></a>
              <a href='https://twitter.com/YiJia_AI' target='_blank' class='details_tew details_icon' ></a>
              <div class="hide_icon1"></div>
              <div class="hide_icon2"></div>
              <div class="hide_icon3"></div>
              <div class="hide_icon4"></div>
            </div>
          </div>
          <div class="float_l details hidden-xs-only">
            <div class="weixin_er">
              <div>
                <img src="http://bu.dressplus.cn/web/static/image/icon_01.jpg" alt="微信二维码" class="weinxin_erweima">
              </div>
              <span class="weixin_gz">
                <span class="weixin_icon hidden-xs-only"></span>
                <span class="weixin_sold hidden-xs-only"></span>
                <span style="color: #fff;">{{$t('footer.wechat')}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_part3">
        <p class='dress'>Copyright ©2014－2018 {{$t('footer.Moshanghua')}} 京ICP备15061733号-1</p>
      </div>
    </footer>
    <footer class="footer_warp hidden-sm-and-up">
      <div class="footer_part2 clearfix">
        <div class="footer_part1_warp">
          <div class="footer_part1 clearfix">
            <span>免 费 试 用 产 品</span><!--
        --><router-link to="/trial" class="link">立 即 申 请</router-link>
          </div>
        </div>
        <div class="footer_bg_m">
          <div class="float_l weixin">
            <div class="weixin_logo">
              <img src="http://bu.dressplus.cn/web/static/image/logo2.png" alt="">
            </div>
            <p style="color: #fff;" class="rengong">人工智能计算机视觉引擎</p>
            <div class="weixin_er">
              <img src="http://bu.dressplus.cn/web/static/image/icon_01.jpg" alt="微信二维码" class="weinxin_erweima">
              <span class="weixin_gz">
                <span class="weixin_icon hidden-xs-only"></span>
                <span class="weixin_sold hidden-xs-only"></span>
                <span style="color: #ccc;">Yi+公众号</span>
              </span>
            </div>
          </div>
          <div class="float_l teamwork clearfix">
            <p class='footer_title'>合作</p>
            <div class="footer_p_warp">
              <p class='footer_p  teamwork_p1'><i class="bd_icon mail_icon"></i>商务</p>
              <a href="mailto:bd@yijia.ai" class="footer_link_m">bd@yijia.ai</a>
              <p class='footer_p'><i class="hr_icon mail_icon"></i>招聘</p>
              <a href="mailto:hr@yijia.ai" class="footer_link_m">hr@yijia.ai</a>
              <p class='footer_p'><i class="pr_icon mail_icon"></i>媒体</p>
              <a href="mailto:pr@yijia.ai" class="footer_link_m">pr@yijia.ai</a>
            </div>
          </div>
          <div class="float_l details hidden-xs-only">
            <div>
              <p class='footer_title'>了解详情</p>
              <p class="details_link">
                <router-link to="/product">产品技术</router-link>
              </p>
              <p class="details_link">
                <router-link to="/solution">解决方案</router-link>
              </p>
              <p class="details_link">
                <router-link to="/about">关于我们</router-link>
              </p>
              <p class="details_link">
                <a href="http://www.lagou.com/gongsi/29151.html" target='_blank'>加入我们</a>
              </p>
            </div>
            <div style="margin-top: 20px">
              <a href=' http://weibo.com/dressplus' target='_blank' class='details_weibo details_icon' ></a>
              <a href='http://i.youku.com/dressjia' target='_blank' class='details_youku details_icon' ></a>
              <a href='https://www.linkedin.com/company/13604619/' target='_blank' class='details_ins details_icon' ></a>
              <a href='https://twitter.com/YiJia_AI' target='_blank' class='details_tew details_icon' ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_part3">
        <p class='dress'>Copyright ©2014－2016 北京陌上花科技有限公司<br>京ICP备15061733号-1</p>
      </div>
    </footer>
  </div>
</template>

<script>
  import bus from '../utils/bus'
  export default {
  	data(){
  		return{
			  showTrialBtnAuth: ['about','newslist'],
			  customEvent: '',
			  authList:''
      }
    },
    watch:{
	    customEvent(val){
		    let showTrialBtnAuth = ''
		    showTrialBtnAuth = this.showTrialBtnAuth.filter(item => {
			    return item === val
		    })
		    this.authList = showTrialBtnAuth
	    }
    },
  	created(){
		  bus.$on('customEvent',(msg) => {
			  //msg就是通过事件 传递来的数据
			  this.customEvent = msg;
		  })
    },
  	computed:{
		  showTrialBtn(){
			  let locale = this.$i18n.locale
			  let authShow = this.authList.length === 0 ? true : false;
			  let localeShow = this.$i18n.locale === 'cn' ? true : false;
			  return authShow&&localeShow
      }
    }
  }
</script>

<style>
  @media screen and (max-width: 767px){
    .footer_warp{
      width: 100%;
    }
    .footer_part1_warp{
      height: 3.28rem;
      background: url("http://bu.dressplus.cn/web/static/image/footer_bg02.png") center no-repeat;
      position: relative;
      background-size: 100% 100%;
    }
    .footer_part1{
      width: 70%;
      height: 0.77rem;
      text-align: center;
      line-height: 0.77rem;
      position: absolute;
      left: 50%;
      top: 1.64rem;
      margin: -0.39rem 0px 0px -35%;
      font-size: 0.32rem;
    }
    .footer_part1 .link1{
      color: #fff;
      box-sizing: border-box;
      height: 100%;
      display: inline-block;
      width: 50%;
      border: 1px solid #fff;
      vertical-align: top;
    }
    .footer_part1 .link{
      vertical-align: top;
      height: 100%;
      display: inline-block;
      width: 50%;
      color: #00a6ff;
      background: #FFF;
    }
    .footer_bg_m{
      background: url("http://bu.dressplus.cn/web/static/image/footer_bj.jpg") center no-repeat;
      text-align: center;
      height: 9.3rem
    }
    .weixin_logo{
      width: 16%;
      margin: 0px auto;
    }
    .weixin{
      padding-top: 0.4rem;
    }
    .weixin_logo>img{
      width: 100%;
    }
    .rengong{
      font-size: 0.32rem;
      margin-top: 0.3rem;
    }
    .weixin_er{
      width: 32%;
      margin: 0px auto;
      font-size: 0.29rem;
    }

    .weixin_er>img{
      width: 100%;
    }
    .weinxin_erweima{
      margin: 0.3rem 0;
      margin-top: 0.6rem;
    }
    .teamwork{

    }
    .footer_title{
      color: #fff;
      font-size: 0.32rem;
      margin-top: 1rem;
    }
    .footer_p_warp{
      height: 0.8rem;
      line-height: 0.4rem;
    }
    .footer_p{
      color: #ccc;
      font-size: 0.29rem;
      display: inline-block;
    }
    .footer_link_m{
      color: #ccc;
      font-size: 0.29rem;
    }
    .footer_part3{
      height: 1.3rem;
      font-size: 0.24rem;
      line-height: 0.4rem;
      background-color: #1D2528;
      color: #DBDCDA;
      text-align: center;
    }
    .dress{
      width: 75%;
      margin: 0 auto;
      padding-top: 0.2rem;
      font-size: 0.15rem;
    }
  }
  @media screen and (min-width: 768px){
    .footer_warp{
      width: 100%;
      text-align: center;
    }
    /*.footer_warp a{
      color: #616161;
    }*/
    .footer_part1_warp{
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235331335.jpeg") no-repeat center;
      height: 320px;
      width: 100%;
      display: flex;
      align-items:center;
      justify-content:center;
    }
    .footer_part1 .link1{
      color: #fff;
      box-sizing: border-box;
      text-align: center;
      font-size: 36px;
    }
    .footer_part1 .link{
      margin-top: 40px;
      color: #00a6ff;
      text-align: center;
      display: inline-block;
      padding: 10px 15px;
      font-size: 22px;
      height: 100%;
      background-color: #fff;
      vertical-align: middle;
    }
    .footer_bg_m{
      width: 100%;
      display: flex;
      background: url("http://bu.dressplus.cn/web/static/image/footer_bj.jpg") no-repeat center;
      background-size: 100% 100%;
      justify-content:center;
    }
    .float_l{
      width: 20%;
      margin-top: 100px;
      margin-bottom: 50px;
    }
    .teamwork{
      color: #ccc;
      padding-left: 100px;
      box-sizing: border-box;
      text-align: left;
      min-width: 248px;
    }
    .teamwork a {
      color: #ccc;
    }
    .footer_part2{
      margin: 0 auto;
    }
    /*微信*/
    .weixin{
      text-align: left;
    }
    .weixin_logo{
      width: 300px;
    }
    .weixin_logo img{
      width: 30%;
    }
    .rengong{
      margin-top: 10px;
    }
    .weixin_gz{
      display: inline-block;
      margin-top: 5px;
    }
    .weinxin_erweima{
      vertical-align: bottom;
      width: 35%;
      min-width: 105px;
    }
    .weixin_icon{
      background: url("http://bu.dressplus.cn/web/static/image/icon_07.png") no-repeat center;
      display: inline-block;
      width: 35px;
      height: 29px;
      vertical-align: middle;
    }
    .weixin_sold{
      vertical-align: middle;
      display: inline-block;
      width: 1px;
      height: 16px;
      background-color: #b2b2b2;
      margin: 0px 10px;
    }
    .footer_part3{
      height: 76px;
      background-color: #1D2528;
      line-height: 76px;
      color: #DBDCDA;
      text-align: center;
      font-size: 12px;
    }

    /*合作*/
    .float_l_text{
      display: flex;
      text-align: left;
    }
    .footer_p_warp{
      width: 50%;
    }
    .footer_title{
      font-size: 17px;
      color: #fff;
      padding-bottom: 25px;
    }
    .footer_p{
      font-size: 14px;
      padding: 10px 0 5px;
      color: #ccc;
      width: 120%;
    }
    .footer_p a{
      color: #ccc;
      margin-left: 8px;
    }
    .teamwork_p1{
      margin-top: -6px;
    }
    .mail_icon{
      display: inline-block;
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
    .bd_icon{
      background: url("http://bu.dressplus.cn/web/static/image/icon_04.png") center no-repeat;
    }
    .hr_icon{
      background: url("http://bu.dressplus.cn/web/static/image/icon_02.png") center no-repeat;
    }
    .pr_icon{
      background: url("http://bu.dressplus.cn/web/static/image/icon_03.png") center no-repeat;
    }
    /*详情*/
    .details{

    }
    .details_link{
      padding: 10px 0;
    }
    .details_link a{
      color: #ccc;
      font-size: 14px;
    }
    .details_icon{
      display: inline-block;
      width: 32px;
      height: 32px;
      padding-right: 15px;
    }
    .details_weibo{
      background: url("http://bu.dressplus.cn/web/static/image/icon_06.png") center no-repeat;
    }
    .details_youku{
      background: url("http://bu.dressplus.cn/web/img/tencent.png") center no-repeat;
    }
    .details_ins{
      background: url("http://bu.dressplus.cn/web/static/image/icon_09.png") center no-repeat;
    }
    .details_tew{
      background: url("http://bu.dressplus.cn/web/static/image/icon_10.png") center no-repeat;
    }
    .details_weibo:hover{
      background: url("http://bu.dressplus.cn/web/static/image/icon_11.png") center no-repeat;
    }
    .details_youku:hover{
      background: url("http://bu.dressplus.cn/web/img/tencent_grey.png") center no-repeat;
    }
    .details_ins:hover{
      background: url("http://bu.dressplus.cn/web/static/image/icon_12.png") center no-repeat;
    }
    .details_tew:hover{
      background: url("http://bu.dressplus.cn/web/static/image/icon_13.png") center no-repeat;
    }
    /*加载icon*/
    .hide_icon1{
      display: none;
      background: url("http://bu.dressplus.cn/web/static/image/icon_11.png") center no-repeat;
    }
    .hide_icon2{
      display: none;
      background: url("http://bu.dressplus.cn/web/img/tencent_grey.png") center no-repeat;

    }
    .hide_icon3{
      display: none;
      background: url("http://bu.dressplus.cn/web/static/image/icon_12.png") center no-repeat;
    }
    .hide_icon4{
      display: none;
      background: url("http://bu.dressplus.cn/web/static/image/icon_13.png") center no-repeat;
    }
  }
  @media screen and (min-width: 768px)and (max-width: 1400px){
    .float_l{
      width: 30%;
      margin-top: 100px;
      margin-bottom: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue